import { differenceInYears, parseISO, isValid } from "date-fns";

// Helper to calculate age from a "YYYY-MM-DD" string
export const calculateAge = (dobString) => {
  try {
    return differenceInYears(new Date(), parseISO(dobString));
  } catch {
    return "N/A";
  }
};

export const calculateAge2 = (dob) => {
  if (!dob) return "N/A";

  let birthDate;

  // Support Date, ISO string, or Firestore Timestamp-like { seconds }
  if (dob instanceof Date) {
    birthDate = dob;
  } else if (typeof dob === "string") {
    const parsed = parseISO(dob);
    if (!isValid(parsed)) return "N/A";
    birthDate = parsed;
  } else if (dob && typeof dob === "object" && typeof dob.seconds === "number") {
    birthDate = new Date(dob.seconds * 1000);
  } else {
    return "N/A";
  }

  // Final validation + future-dates guard
  if (!isValid(birthDate)) return "N/A";
  const today = new Date();
  if (birthDate > today) return "N/A";

  const years = Math.max(0, differenceInYears(today, birthDate));
  return `${years} ${years === 1 ? "year" : "years"}`;
};



export const generateKeywords = (str) =>
  str
    .toLowerCase()
    .split(/[\s\-]+/) // split by space or dash
    .filter(Boolean);

    export const generateKeywordsByCharacters = (text) => {
  if (!text) return [];

  const lowered = text.trim().toLowerCase();
  const keywords = [];

  let current = "";
  for (const char of lowered) {
    current += char;
    keywords.push(current);
  }

  return keywords;
};

export const hospitalSlugMapReverse = {
  "hospital_002": "clearhealth",
  "CH-GM-01": "onmac",
  // Add more hospitalId → slug mappings as needed
};

export const hospitalSlugMap = {
  clearhealth: "hospital_002",
  onmac: "CH-GM-01",
  //fmcg: "hospital_003",
  // Add more mappings here
};

export const calculateDaysSince2 = (timestamp) => {
  if (!timestamp) return 0;

  const assignedDate = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
  const now = new Date();

  // Calculate difference in milliseconds
  const diffMs = now - assignedDate;

  // Convert to full days
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

  return diffDays;
};

// each calendar day counts as one regardless of 24-hour cycles
// export const calculateDaysSince = (timestamp) => {
//   if (!timestamp) return 0;

//   const assignedDate = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
//   const now = new Date();

//   // Reset both dates to midnight to ignore time part
//   const assignedMidnight = new Date(assignedDate.getFullYear(), assignedDate.getMonth(), assignedDate.getDate());
//   const nowMidnight = new Date(now.getFullYear(), now.getMonth(), now.getDate());

//   // Calculate the difference in days
//   const diffMs = nowMidnight - assignedMidnight;
//   const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

//   return diffDays;
// };
// each calendar day counts as one regardless of 24-hour cycles
export const calculateDaysSince = (timestamp) => {
  if (!timestamp) return 0;

  let assignedDate;

  if (timestamp instanceof Date) {
    assignedDate = timestamp;
  } else if (timestamp.toDate) {
    assignedDate = timestamp.toDate();
  } else if (timestamp.seconds) {
    assignedDate = new Date(timestamp.seconds * 1000);
  } else {
    // Fallback for unexpected format
    assignedDate = new Date(timestamp);
  }

  if (isNaN(assignedDate.getTime())) return 0;

  const now = new Date();

  // Reset both dates to midnight to ignore time part
  const assignedMidnight = new Date(assignedDate.getFullYear(), assignedDate.getMonth(), assignedDate.getDate());
  const nowMidnight = new Date(now.getFullYear(), now.getMonth(), now.getDate());

  const diffMs = nowMidnight - assignedMidnight;
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

  return diffDays;
};


export const calculateDaysBetween = (startTimestamp, endTimestamp) => {
  if (!startTimestamp || !endTimestamp) return 0;

  const startDate = startTimestamp.toDate ? startTimestamp.toDate() : new Date(startTimestamp);
  const endDate = endTimestamp.toDate ? endTimestamp.toDate() : new Date(endTimestamp);

  // Strip time from both dates (midnight comparison)
  const startMidnight = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());
  const endMidnight = new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate());

  // Calculate difference in full calendar days
  const diffMs = endMidnight - startMidnight;
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

  return diffDays;
};
export const formatDate = (date) => {
  if (!date) return "";
  const d = date instanceof Date ? date : date.toDate?.();
  if (!d) return "";
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};



